import { Typography, Button, Modal, Tooltip, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { useAPI } from "../../API/useAPI";
import DeleteIcon from "@mui/icons-material/Delete";
import { useContext, useEffect, useState } from "react";
import { SnackbarContext } from "../../contexts/SnackbarProvider";
import { useConfirm } from "material-ui-confirm";

interface Props {
  ids: number[];
  signalFetchJourReports: () => void;
}

/**
 * Button to delete report
 *
 *
 * @param {id}
 * @returns
 */
export default function BulkDeleteButton({
  ids,
  signalFetchJourReports,
}: Props) {
  const snackBar = useContext(SnackbarContext);
  const api = useAPI();
  const confirm = useConfirm();
  const [deleteReport, setDeleteReport] = useState(false);

  useEffect(() => {
    const handleDelete = async () => {
      if (deleteReport) {
        setDeleteReport(false);
        const res = await api.jourReports.deleteMany(ids);
        if (res.error) {
          snackBar.show("Kunde inte radera rapport.", "error");
        } else {
          snackBar.show("Rapport raderad", "success");
        }
        signalFetchJourReports();
      }
    };

    handleDelete();
  }, [deleteReport, setDeleteReport, ids, snackBar]);

  const handleButtonPress = () => {
    confirm({
      title: "Är du säker?",
      description: `Du är påväg att radera ${ids.length} rapporter`,
      confirmationText: "Radera rapport",
      cancellationText: "Avbryt",
      confirmationButtonProps: { autoFocus: true },
      allowClose: true,
    })
      .then(() => {
        console.log("delete report!");
        setDeleteReport(true);
      })
      .catch(() => {
        console.log("not deleting any report");
      });
  };

  return (
    <Tooltip title="Radera rapporter">
      <IconButton onClick={() => handleButtonPress()}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}
